// (https://ru.wikipedia.org/wiki/Коды_языков)

export const en = {
    "ru": "Russian",
    "en": "English",
    "ar": "Classic Arabic",
} as const;
export const ru = {
    "ru": "Русский",
    "en": "Английский",
    "ar": "Арабский",
} as const;
